import React from 'react';
import "../styling/NewMember.css"

import { NavLink } from 'react-router-dom';
 
const NewMember = () => {

    return (
      <div id='about'>
         <h1>About my girl</h1>
         <p>Hey! This is Sakshi</p>
            <img 
            src="/her_image.jpg" 
            alt="Pic of my girl" 
            />
         <p>From the moment you came into my life, you became my home in Boston.
            You are the peace I didn’t know I needed and the joy I never imagined was possible. Every day with you is a new adventure, and I wouldn’t trade a single second.
            </p>

            <p>You have this incredible way of filling my world with love and laughter. The way you care for me, the way you make the tastiest food, and the way you stay by my side even when I’m being stubborn — I can’t express how grateful I am.</p>

            <p>I know I’m not always the easiest person to live with, but somehow, you manage to love me through it all. Thank you for being my anchor, my heart, and my Gundi. You make everything better just by being you.
            </p>

            <p>To my Penguin, my love, and my best friend - from your Groot. ❤️</p>
         <br></br>
         <p></p>
      </div>
    );
}
 
export default NewMember;